import './LoadingScreen.scss';

function LoadingScreen() {
    return (
        <div id="loading-wrapper">
            <div id="loading">Loading</div>
        </div>
    )
}

export default LoadingScreen;